export const formatCPF = (cpf: string | undefined): string => {
  if (!cpf) {
    return ''
  }

  return cpf.replace(/[.-]/g, '')
}
